import { Component } from '@angular/core';

@Component({
  selector: 'app-ceil-element-hover',
  templateUrl: './ceil-element-hover.component.html',
  styleUrls: ['./ceil-element-hover.component.scss']
})
export class CeilElementHoverComponent {}
